/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spare_Aware_Piranha_FeastInputs */

const fr_spare_aware_piranha_feast = /** @type {(inputs: Spare_Aware_Piranha_FeastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les notifications`)
};

/**

* @param {Spare_Aware_Piranha_FeastInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spare_aware_piranha_feast = /** @type {((inputs?: Spare_Aware_Piranha_FeastInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spare_Aware_Piranha_FeastInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spare_aware_piranha_feast(inputs)
});